<template>
  <div>
    <b-jumbotron>
      <b-row align-h="between">
        <b-col cols="4">
          <label for="filterInput">Search</label>
          <b-form-input
            size="sm"
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
        </b-col>
        <b-col cols="2">
          <b-button
            v-b-modal="'idBranchDetailImportModal'"
            id="idImportBtn"
            size="sm"
            variant="outline-primary"
            style="margin:0 1rem"
          >Import</b-button>
          <b-button id="idNewBtn" size="sm" variant="outline-primary" @click="onNewClicked">New</b-button>
        </b-col>
      </b-row>
    </b-jumbotron>
    <AdminAreaBranchDetailTabNewHospitalModal
      :hospital="selectedItem"
      @newHospital="handleNewHospital"
      @updateHospital="handleUpdateHospital"
    />
    <AdminAreaBranchDetailTabNewUserModal
      :user="selectedItem"
      @newUser="handleNewUser"
      @updateUser="handleUpdateUser"
    />
    <AdminAreaBranchDetailTabNewScanFacilityModal
      :scanFacility="selectedItem"
      @newScanFacility="handleNewScanFacility"
      @updateScanFacility="handleUpdateScanFacility"
    />
    <AdminAreaBranchDetailTabNewSurgeonModal
      :surgeon="selectedItem"
      @newSurgeon="handleNewSurgeon"
      @updateSurgeon="handleUpdateSurgeon"
    />
    <AdminAreaBranchDetailTabImportModal :type="type" @import="handleImport" />
    <div v-if="!showSpinner">
      <b-table
        head-variant="light"
        outlined
        responsive="sm"
        small
        per-page="20"
        :filter="filter"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :filter-ignored-fields="['id']"
        @filtered="onFiltered"
      >
        <template v-slot:cell(actions)="row">
          <b-button-group>
            <b-button
              size="sm"
              @click="onEditClicked(row.item)"
              variant="outline-primary"
              v-b-modal="'idNewBranchModal'"
            >
              <b-icon scale=".9" icon="pencil-square"></b-icon>Edit
            </b-button>
            <b-button size="sm" @click="onDeleteClicked(row.item)" variant="outline-primary">
              <b-icon scale=".9" icon="trash"></b-icon>Delete
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-pagination
        style="margin-right: 1rem"
        v-model="currentPage"
        :total-rows="totalRows"
        first-number
        last-number
        per-page="20"
        align="right"
      />
    </div>
    <b-spinner
      variant="warning"
      class="m-5"
      style="width: 3rem; height: 3rem;"
      v-if="this.showSpinner"
    ></b-spinner>
  </div>
</template>

<script>
import AdminAreaBranchDetailTabNewHospitalModal from "@/components/AdminAreaBranchDetailTabNewHospitalModal.vue";
import AdminAreaBranchDetailTabNewUserModal from "@/components/AdminAreaBranchDetailTabNewUserModal.vue";
import AdminAreaBranchDetailTabNewSurgeonModal from "@/components/AdminAreaBranchDetailTabNewSurgeonModal.vue";
import AdminAreaBranchDetailTabNewScanFacilityModal from "@/components/AdminAreaBranchDetailTabNewScanFacilityModal.vue";
import AdminAreaBranchDetailTabImportModal from "@/components/AdminAreaBranchDetailTabImportModal.vue";

export default {
  data() {
    return {
      selectedItem: null,
      showSpinner: false,
      fieldsDict: {
        user: [
          { key: "userId", sortable: true },
          { key: "firstName", sortable: true },
          { key: "lastName", sortable: true },
          { key: "e-Mail", sortable: true },
          { key: "actions", sortable: false },
        ],
        hospital: [
          { key: "hospitalId", sortable: true },
          { key: "hospitalName", sortable: true },
          { key: "actions", sortable: false },
        ],
        scanFacility: [
          { key: "scanFacilityId", sortable: true },
          { key: "scanFacilityName", sortable: true },
          { key: "shareCode", sortable: true },
          { key: "city", sortable: true },
          { key: "state", sortable: true },
          { key: "country", sortable: true },
          { key: "actions", sortable: false },
        ],
        surgeon: [
          { key: "surgeonId", sortable: true },
          { key: "firstName", sortable: true },
          { key: "lastName", sortable: true },
          { key: "actions", sortable: false },
        ],
      },
      items: null,
      fields: null,
      totalRows: 1,
      currentPage: 1,
      filter: null,
      loading: false,
    };
  },
  props: ["type", "branchId"],
  components: {
    AdminAreaBranchDetailTabNewHospitalModal,
    AdminAreaBranchDetailTabNewUserModal,
    AdminAreaBranchDetailTabNewSurgeonModal,
    AdminAreaBranchDetailTabNewScanFacilityModal,
    AdminAreaBranchDetailTabImportModal,
  },
  async created() {
    this.showSpinner = true;
    this.fields = this.fieldsDict[this.type];
    await this.retrieveDataByType();
    this.totalRows = this.items.length;
    this.showSpinner = false;
  },
  methods: {
    onEditClicked(item) {
      switch (this.type) {
        case "user":
          this.$store.commit("SET_USER_TO_EDIT", item);
          this.$bvModal.show("idBranchDetailNewUserModal");
          break;
        case "hospital":
          this.$store.commit("SET_HOSPITAL_TO_EDIT", item);
          this.$bvModal.show("idBranchDetailNewHospitalModal");
          break;
        case "surgeon":
          this.$store.commit("SET_SURGEON_TO_EDIT", item);
          this.$bvModal.show("idBranchDetailNewSurgeonModal");
          break;
        case "scanFacility":
          this.$store.commit("SET_FACILITY_TO_EDIT", item);
          this.$bvModal.show("idBranchDetailNewScanFacilityModal");
          break;
        default:
          break;
      }
    },
    async onDeleteClicked(item) {
      let deleteMsg = "";
      switch (this.type) {
        case "user":
          deleteMsg = `Are you sure you want to delete the User: ${item.firstName} ${item.lastName}?`;
          break;
        case "hospital":
          deleteMsg = `Are you sure you want to delete the Hospital: ${item.hospitalName}?`;
          break;
        case "surgeon":
          deleteMsg = `Are you sure you want to delete the Surgeon: ${item.firstName} ${item.lastName}?`;
          break;
        case "scanFacility":
          deleteMsg = `Are you sure you want to delete the Scan Facility: ${item.scanFacilityName}?`;
          break;
        default:
          break;
      }

      const deleteConfirm = await this.$bvModal.msgBoxConfirm(deleteMsg, {
        title: `Delete ${this.type}`,
        size: "md",
        buttonSize: "md",
        okVariant: "primary",
        okTitle: "Accept",
        cancelVariant: "outline-primary",
        cancelTitle: "Cancel",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
      });
      if (!deleteConfirm) return;
      this.loading = true;
      try {
        switch (this.type) {
          case "user":
            await this.$buhApi.branchesBranchIdUsersUserIdDelete(
              this.branchId,
              item.id
            );
            break;
          case "hospital":
            await this.$buhApi.branchesHospitalsIdDelete(item.id);
            break;
          case "surgeon":
            await this.$buhApi.branchesSurgeonsIdDelete(item.id);
            break;
          case "scanFacility":
            await this.$buhApi.branchesScanfacilitiesIdDelete(item.id);
            break;
          default:
            break;
        }
      } catch (error) {
        this.loading = false;
        this.$root.$emit("showAlert", {
          type: "error",
          msg: `Error ${error.status} while deleting`,
        });
      }
      this.items = this.items.filter((el) => el.id !== item.id);
      this.totalRows = this.items.length;
      this.$root.$emit("showAlert", {
        type: "info",
        msg: `${this.type} deleted`,
      });
      this.loading = false;
    },
    async retrieveDataByType() {
      this.showSpinner = true;
      try {
        switch (this.type) {
          case "user":
            var usersResponse = await this.$buhApi.branchesIdUsersGet(
              this.branchId
            );
            this.items = usersResponse.map((user) => {
              return {
                id: user.entityId,
                userId: user.externalReference,
                firstName: user.firstName,
                lastName: user.lastName,
                "e-Mail": user.userEmail,
              };
            });
            this.totalRows = this.items.length;
            break;
          case "surgeon":
            var surgeonResponse = await this.$buhApi.branchesIdSurgeonsGet(
              this.branchId
            );
            this.items = surgeonResponse.map((surgeon) => {
              return {
                id: surgeon.entityId,
                surgeonId: surgeon.externalReference,
                firstName: surgeon.firstName,
                lastName: surgeon.lastName,
              };
            });
            this.totalRows = this.items.length;
            break;
          case "hospital":
            var hospitalResponse = await this.$buhApi.branchesIdHospitalsGet(
              this.branchId
            );
            this.items = hospitalResponse.map((hospital) => {
              return {
                id: hospital.entityId,
                hospitalId: hospital.externalReference,
                hospitalName: hospital.hospitalName,
              };
            });
            this.totalRows = this.items.length;
            break;
          case "scanFacility":
            var scanFacilityResponse = await this.$buhApi.branchesIdScanfacilitiesGet(
              this.branchId
            );
            this.items = scanFacilityResponse.map((scanFacility) => {
              return {
                id: scanFacility.entityId,
                scanFacilityId: scanFacility.externalReference,
                shareCode: scanFacility.entityId,
                scanFacilityName: scanFacility.facilityName,
                city: scanFacility.city,
                state: scanFacility.state,
                country: scanFacility.country,
              };
            });
            this.totalRows = this.items.length;
            break;
          default:
            throw new Error(`Unknown type ${this.type}`);
        }
      } catch (error) {
        this.showSpinner = false;
        this.$root.$emit("showAlert", {
          type: "error",
          msg: `Error while retrieving list of ${this.type}`,
        });
        // eslint-disable-next-line
        console.log(error);
      }
      this.showSpinner = false;
    },
    async handleNewHospital(item) {
      await this.$buhApi.branchesIdHospitalsPost(this.branchId, item);
      await this.retrieveDataByType();
    },
    async handleNewUser(item) {
      await this.$buhApi.branchesIdUsersPost(this.branchId, item);
      await this.retrieveDataByType();
    },
    async handleNewSurgeon(item) {
      await this.$buhApi.branchesIdSurgeonsPost(this.branchId, item);
      await this.retrieveDataByType();
    },
    async handleNewScanFacility(item) {
      await this.$buhApi.branchesIdScanfacilitiesPost(this.branchId, item);
      await this.retrieveDataByType();
    },
    async handleUpdateHospital(item) {
      await this.$buhApi.branchesHospitalsIdPut(item.id, {
        hospitalName: item.hospitalName,
      });
      await this.retrieveDataByType();
    },
    async handleUpdateUser(item) {
      await this.$buhApi.branchesUsersIdPut(item.id, {
        firstName: item.firstName,
        lastName: item.lastName,
        userEmail: item.userEmail,
      });
      await this.retrieveDataByType();
    },
    async handleUpdateSurgeon(item) {
      await this.$buhApi.branchesSurgeonsIdPut(item.id, {
        firstName: item.firstName,
        lastName: item.lastName,
      });
      await this.retrieveDataByType();
    },
    async handleUpdateScanFacility(item) {
      await this.$buhApi.branchesScanfacilitiesIdPut(item.id, {
        facilityName: item.facilityName,
        city: item.city,
        state: item.state,
        country: item.country,
      });
      await this.retrieveDataByType();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async handleImport(file) {
      var reader = new FileReader();
      reader.onload = async (event) => {
        const file = event.target.result;
        const allLines = file.split(/\r\n|\n/);
        const header = allLines[0].split(";");
        let body = [];
        let kind = "";
        allLines.shift();
        try {
          switch (this.type) {
            case "user":
              if (
                header.length !== 3 ||
                header[0].toLocaleLowerCase() !== "first name" ||
                header[1].toLocaleLowerCase() !== "last name" ||
                header[2].toLocaleLowerCase() !== "e-mail"
              ) {
                throw "Imported file is not suitable for type 'User'";
              }
              allLines.forEach((line) => {
                if (line !== "") {
                  var [firstName, lastName, email] = line.split(";");
                  if (firstName === "")
                    throw "Mandatory Field 'First Name' is missing for one or more entries";
                  else if (lastName === "")
                    throw "Mandatory Field 'Last Name' is missing for one or more entries";
                  else if (email === "")
                    throw "Mandatory Field 'E-Mail' is missing for one or more entries";
                  body.push({
                    firstName: firstName.trim(),
                    lastName: lastName.trim(),
                    userEmail: email.trim(),
                  });
                }
              });
              kind = "users";
              break;
            case "hospital":
              if (
                header.length !== 1 ||
                header[0].toLocaleLowerCase() !== "hospital name"
              ) {
                throw "Imported file is not suitable for type 'Hospital'";
              }
              allLines.forEach((line) => {
                if (line !== "") {
                  body.push({
                    hospitalName: line.trim(),
                    hospitalLocation: { address: "n/a" },
                  });
                }
              });
              kind = "hospitals";
              break;
            case "surgeon":
              if (
                header.length !== 2 ||
                header[0].toLocaleLowerCase() !== "first name" ||
                header[1].toLocaleLowerCase() !== "last name"
              ) {
                throw "Imported file is not suitable for type 'Surgeon'";
              }
              allLines.forEach((line) => {
                if (line !== "") {
                  var [firstName, lastName] = line.split(";");
                  if (firstName === "")
                    throw "Mandatory Field 'First Name' is missing for one or more entries";
                  else if (lastName === "")
                    throw "Mandatory Field 'Last Name' is missing for one or more entries";
                  body.push({ firstName: firstName.trim(), lastName: lastName.trim() });
                }
              });
              kind = "surgeons";
              break;
            case "scanFacility":
              if (
                header.length !== 4 ||
                header[0].toLocaleLowerCase() !== "scan facility name" ||
                header[1].toLocaleLowerCase() !== "city" ||
                header[2].toLocaleLowerCase() !== "state" ||
                header[3].toLocaleLowerCase() !== "country"
              ) {
                throw "Imported file is not suitable for type 'Scan Facility'";
              }
              allLines.forEach((line) => {
                if (line !== "") {
                  var [facilityName, city, state, country] = line.split(";");
                  if (facilityName === "")
                    throw "Mandatory Field 'Facility Name' is missing for one or more entries";
                  body.push({
                    facilityName: facilityName.trim(),
                    city: city.trim(),
                    state: state.trim(),
                    country: country.trim(),
                  });
                }
              });
              kind = "scanfacilities";
              break;
          }
        } catch (e) {
          // eslint-disable-next-line
          console.log(e);
          this.$root.$emit("showAlert", {
            type: "error",
            msg: e,
          });
          return;
        }
        this.showSpinner = true;
        try {
          const bulkResponse = await this.$buhBulkApi.branchesIdBulkimportPost(
            this.branchId,
            kind,
            body
          );
          const failedImports = bulkResponse.filter(
            (res) => !res.importSuccessful
          );
          if (failedImports.length >= 1) {
            this.$root.$emit("showAlert", {
              type: "error",
              msg: `One or more imports failed. See console log for details.`,
            });
            // eslint-disable-next-line
            console.log("Error while importing! The following imports failed:");
            // eslint-disable-next-line
            console.log(failedImports);
          }
          await this.retrieveDataByType();
        } catch (error) {
          this.$root.$emit("showAlert", {
            type: "error",
            msg: `Error ${error.status} while importing ${this.type}`,
          });
        }
      };
      reader.onerror = (event) => {
        alert(event.target.error.name);
      };
      reader.readAsText(file);
    },
    onNewClicked() {
      this.selectedItem = null;
      switch (this.type) {
        case "user":
          this.$bvModal.show("idBranchDetailNewUserModal");
          break;
        case "hospital":
          this.$bvModal.show("idBranchDetailNewHospitalModal");
          break;
        case "surgeon":
          this.$bvModal.show("idBranchDetailNewSurgeonModal");
          break;
        case "scanFacility":
          this.$bvModal.show("idBranchDetailNewScanFacilityModal");
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style>
</style>